import StaticLayout from '../components/StaticLayout';

const Changelog = () => (
  <StaticLayout title="Lampant | What's New">
    <div className="w-full lg:max-w-5xl px-4 lg:px-0 mx-auto mt-24">
      <h2 className="text-4xl font-medium text-indigo-400 my-6">
        New features and improvements
      </h2>

      <div className="my-12">
        <h3 className="font-medium text-xl my-4">Jun 5th, 2022</h3>
        <div>
          <h4 className="font-medium">Delete ideas</h4>
          <p>
            Finally! If you want to delete one of your ideas, just click the new
            "Delete" button in the Idea page.
          </p>
        </div>
        <div>
          <h4 className="font-medium">Search includes tags</h4>
          <p>
            Instead of just searching on idea's titles, we now return ideas that
            have tags matching the search term.
          </p>
        </div>
      </div>

      <div className="my-12">
        <h3 className="font-medium text-xl my-4">Jan 4th, 2022</h3>
        <div>
          <h4 className="font-medium">Zapier and Slack integrations</h4>
          <p>
            You can now connect your Slack account and have all your ideas sent
            to a defined slack channel. If you want to integrate with further
            tools, we now support Zapier. Go to your profile to setup it up.
          </p>
        </div>
      </div>

      <div className="my-12">
        <h3 className="font-medium text-xl my-4">July 20th, 2021</h3>
        <div>
          <h4 className="font-medium">Allowed Domains</h4>
          <p>
            Want to allow all the people from your organization to join you in
            Lampant without the having to go through SSO? Now it's easy! Just
            add a domain and verify it. Once new people sign up with a{' '}
            <span className="font-bold">verified</span> email address from that
            domain they will be given an option to join your organization right
            in the onboarding flow! Check it out in your organization's settings
            page.
          </p>
        </div>
      </div>

      <div className="my-12">
        <h3 className="font-medium text-xl my-4">July 18th, 2021</h3>
        <div className="space-y-4">
          <div>
            <h4 className="font-medium">Pitch visible in idea page</h4>
            <p>
              The idea pitch is now front and center in the idea page. It's best
              way to get people excited about your idea.
            </p>
          </div>
          <div>
            <h4 className="font-medium">Roles and permissions</h4>
            <p>
              Now it's possible to change the role of your team members. In the
              team page, you can choose between the Admin, Maintainer and
              Standard roles for each person.
            </p>
          </div>
        </div>
      </div>
    </div>
  </StaticLayout>
);

export default Changelog;
